import { z } from "zod"
import { ServiceAdvisorDtoSchema, ServiceGapDtoSchema } from "./ServiceDto"

export const ServiceGapUpdateDtoSchema = ServiceGapDtoSchema.omit({ orgId: true, lastUpdated: true, lastUpdatedByUserId: true, order: true })
export type ServiceGapUpdateDto = z.output<typeof ServiceGapUpdateDtoSchema>

export const ServiceAdvisorUpdateDtoSchema = ServiceAdvisorDtoSchema.omit({ orgId: true, lastUpdated: true, lastUpdatedByUserId: true, order: true })
export type ServiceAdvisorUpdateDto = z.output<typeof ServiceAdvisorUpdateDtoSchema>
